import ExtendedLandlordInformationModal from './ExtendedLandlordInformationModal';

export default ExtendedLandlordInformationModal;
